import { HighlightPipe } from './search.highlighter.pipe';
import { discountReportFilter, automatedBillingFilter, abandonedCartFilter, ticketFilter, tosOffendorFilter, clientFilesFilter, uploadedFilesFilter, uploadedLogsFilter, registryFilter, arrayFilter, updateLogFilter, arrayFilterSubKeys, macFilter, phoneWhitelistFilter, addressWhitelistFilter } from './filter.pipe';
import { NgModule } from '@angular/core';

// PIPES
import { AddYearsToDatePipe } from './add-years-to-date.pipe';
import { BillingCyclePipe } from './billing.cycle.pipe';
import { CapitalizeFirstLetterPipe } from './captialize_first_letter.pipe';
import { EmailTemplateFilterPipe } from './email.template.filter.pipe';
import { FilterPipe, FilterByTicketStatusPipe, FilterGISCreditsPipe, tosIPFilterPipe, trainingClassFilter, noteFilter, ownLicenseFilter, designerLicenseFilter, creditBundleFilter, creditUsageFilter, invoiceFilter, creditCardFilter, creditFilter, activityFilter, adminLogFilter, memberLogFilter, authenticationLogFilter, emailLogFilter, trainingHistoryFilter, emailTemplatesListFilter, orderReportFilter, toChargeItemFilter, yardFilesFilter, invoiceReportFilter, creditReportFilter } from './filter.pipe';
import { ProductStatusPipe } from './product.status.pipe';
import { MemberStatusPipe } from './member.status.pipe';
import { SanitizeHtmlPipe } from './sanitize-html.pipe';
import { TicketStatusPipe, TicketStatusCSSPipe } from './ticket.status.pipe';
import { LogTypePipe } from './log.pipes';
import { ActivityTypePipe } from './activity.type.pipe';
import { CountryAbbreviationPipe } from './country.pipe';
import { GetHoldStatusPipe } from './hold.pipes';
import { PhoneFormatPipe } from './phone.format.pipe';

@NgModule({
    declarations: [
        AddYearsToDatePipe,
        BillingCyclePipe,
        CapitalizeFirstLetterPipe,
        FilterPipe,
        EmailTemplateFilterPipe,
        ProductStatusPipe,
        MemberStatusPipe,
        TicketStatusPipe,
        TicketStatusCSSPipe,
        FilterByTicketStatusPipe,
        FilterGISCreditsPipe,
        SanitizeHtmlPipe,
        tosIPFilterPipe,
        LogTypePipe,
        ActivityTypePipe,
        trainingClassFilter,
        noteFilter,
        ownLicenseFilter,
        designerLicenseFilter,
        creditBundleFilter,
        creditUsageFilter,
        invoiceFilter,
        creditCardFilter,
        creditFilter,
        activityFilter,
        adminLogFilter,
        memberLogFilter,
        authenticationLogFilter,
        updateLogFilter,
        emailLogFilter,
        trainingHistoryFilter,
        emailTemplatesListFilter,
        orderReportFilter,
        toChargeItemFilter,
        yardFilesFilter,
        CountryAbbreviationPipe,
        invoiceReportFilter,
        creditReportFilter,
        discountReportFilter,
        automatedBillingFilter,
        abandonedCartFilter,
        macFilter,
        phoneWhitelistFilter,
        addressWhitelistFilter,
        HighlightPipe,
        ticketFilter,
        tosOffendorFilter,
        clientFilesFilter,
        uploadedFilesFilter,
        uploadedLogsFilter,
        registryFilter,
		arrayFilter,
        arrayFilterSubKeys,
		
		GetHoldStatusPipe,
        PhoneFormatPipe,
    ],
    exports: [
        AddYearsToDatePipe,
        BillingCyclePipe,
        CapitalizeFirstLetterPipe,
        FilterPipe,
        EmailTemplateFilterPipe,
        ProductStatusPipe,
        MemberStatusPipe,
        TicketStatusPipe,
        TicketStatusCSSPipe,
        FilterByTicketStatusPipe,
        FilterGISCreditsPipe,
        SanitizeHtmlPipe,
        tosIPFilterPipe,
        LogTypePipe,
        ActivityTypePipe,
        trainingClassFilter,
        noteFilter,
        ownLicenseFilter,
        designerLicenseFilter,
        creditBundleFilter,
        creditUsageFilter,
        invoiceFilter,
        creditCardFilter,
        creditFilter,
        activityFilter,
        adminLogFilter,
        memberLogFilter,
        authenticationLogFilter,
        updateLogFilter,
        emailLogFilter,
        trainingHistoryFilter,
        emailTemplatesListFilter,
        orderReportFilter,
        toChargeItemFilter,
        yardFilesFilter,
        CountryAbbreviationPipe,
        invoiceReportFilter,
        creditReportFilter,
        discountReportFilter,
        automatedBillingFilter,
        abandonedCartFilter,
        macFilter,
        phoneWhitelistFilter,
        addressWhitelistFilter,
        HighlightPipe,
        ticketFilter,
        tosOffendorFilter,
        clientFilesFilter,
        uploadedFilesFilter,
        uploadedLogsFilter,
        registryFilter,
		arrayFilter,
        arrayFilterSubKeys,
		
		GetHoldStatusPipe,
        PhoneFormatPipe,

    ]
})

export class PipesModule {}
